firebird.factory('videoFileShareService', [
    '$rootScope',
    '$window',
    'logService',
    'meetingService',
    'localizationService',
    'videoGlobalService',
    'helperService',
    'videoPlaybackControlsBridge',
    'executionEnvironmentEnum',
    function (
        $rootScope,
        $window,
        logService,
        meetingService,
        localizationService,
        videoGlobalService,
        helperService,
        videoPlaybackControlsBridge,
        executionEnvironmentEnum
    ) {
        var service = {
            initialize: initialize
        };

        var self, $scope;

        const logger = logService.createLoggerWithSource('[videoroomCtrl] videoFileShareService');

        return service;

        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            // file play stream is used for video part of file play, whereas screenstream stores
            // both audio and video, and across reconnections.
            self.fileplaystream = null;

            // file sharing and playback.

            // whether screenshare is actually file play? In which case all the variables
            // and functions that are for screen share are reused but for file play.
            self.fileplay = false;

            self.fileVideo = null; // video element for file play
            self.filePreviewControls = null;
            self.abortFileShare = false;

            self.createFileVideo = createFileVideo;
            self.removeFileVideo = removeFileVideo;
            self.onFilePlayInputChange = onFilePlayInputChange;

            // when the local file share button is clicked
            $scope.$on('start-local-file-share', onStartLocalFileShare);
        }

        // When start-local-file-share event is received, on button click, prompt the user
        // to select an mp4 or mov file. Start a new video publisher in the video room for file playback.
        function onStartLocalFileShare() {
            if (self.screenshareState || self.screenshareOwner) {
                logger.log('videoroomCtrl onStartLocalFileShare() failed, as screen share is active');
                return;
            }

            //Toggles the browser file selection window
            $window.$('#videoroom-fileplay-upload').click();
        }

        function onFilePlayInputChange(event) {
            logger.log(
                'videoroomCtrl onStartLocalFileShare() selected ' + $window.$('#videoroom-fileplay-upload').val()
            );

            if (meetingService.isAllowedByHostSecuritySettings('canShareScreenOrVideo') === false) {
                logger.warn('onFilePlayInputChange', 'sharing video file is disabled by host');

                $rootScope.$broadcast('notify-of-security-change');
            } else {
                if (self.screenshareState || self.screenshareOwner) {
                    logger.warn(
                        'onFilePlayInputChange',
                        'onStartLocalFileShare() already sharing content, cannot proceed.'
                    );
                    self.showAlert(
                        localizationService.translate('SCREENSHARE.DIALOG.PLEASE_TRY_AGAIN'),
                        localizationService.translate('SCREENSHARE.DIALOG.CAN_NOT_SHARE_CONTENT')
                    );
                } else {
                    self.fileplay = true;

                    var file = $window.$('#videoroom-fileplay-upload').get(0).files[0];
                    if (file) {
                        var type = file.type;

                        // local video play should be muted so that audio from freeswitch can be heard.
                        // that audio includes the local video file's audio track too, but with a delay.
                        var video = (self.fileVideo = $window
                            .$(
                                '<video playsinline loop controls disablePictureInPicture controlsList="nodownload nofullscreen noremoteplayback"></video>'
                            )
                            .get(0));
                        video.className = 'fileplay';
                        var videoVolume = (video.volume = 0.001); // ANYAM-70387 - muted does not work, so set volume to very low, and do not allow change.
                        var canPlay = video.canPlayType(type);
                        if (!canPlay) {
                            self.showAlert(
                                localizationService.translate('SCREENSHARE.DIALOG.CAN_NOT_PLAY_VIDEO_FILE', {
                                    extension: file.type.split('/').pop()
                                })
                            );
                            self.removeFileVideo();
                            self.fileplay = false;
                        } else {
                            var fileURL = URL.createObjectURL(file);
                            video.src = fileURL;

                            // Without loop, ended event is triggered, which causes oninactive event, and
                            // terminates the capture stream. So I use loop, and when it loops back to beginning,
                            // I pause the video. This allow the video to be loaded without oninactive and
                            // media stream to be active, so that the video can be played again without disruption.
                            video.lastTime = -1;
                            video.manualSeekInProgress = false;

                            video.addEventListener('seeking', function () {
                                video.manualSeekInProgress = true;
                            });

                            video.addEventListener('seeked', function () {
                                video.lastTime = video.currentTime;
                                video.manualSeekInProgress = false;
                            });

                            video.addEventListener('timeupdate', function (event) {
                                if (video.manualSeekInProgress) {
                                    video.lastTime = video.currentTime;
                                    return;
                                }

                                if (
                                    video.lastTime >= 0 &&
                                    video.currentTime < video.lastTime &&
                                    video.currentTime <= 1 &&
                                    video.lastTime >= Math.max((video.duration || 0) - 1, 0)
                                ) {
                                    logger.log(
                                        'videoroomCtrl pausing video play on loop start: ' +
                                            video.currentTime +
                                            '<' +
                                            video.lastTime
                                    );
                                    video.pause();
                                }
                                video.lastTime = video.currentTime;
                            });

                            // do not allow change in volume
                            video.addEventListener('volumechange', function (event) {
                                if (video.volume != videoVolume) {
                                    video.volume = videoVolume;
                                    self.showAlert(
                                        localizationService.translate('SCREENSHARE.DIALOG.CAN_NOT_UNMUTE_THIS_VIDEO')
                                    );
                                }
                            });

                            video.addEventListener('error', function (event) {
                                var error = 'failed to play';
                                URL.revokeObjectURL(fileURL);
                                self.removeFileVideo();

                                self.showAlert(
                                    localizationService.translate(
                                        'SCREENSHARE.DIALOG.THERE_WAS_A_PROBLEM_SHARING_VIDEO'
                                    )
                                );
                                if (self.fileplay) {
                                    self.fileplay = false;
                                }

                                try {
                                    if (event.path && event.path[0]) {
                                        error = event.path[0].error;
                                    } else if (event.originalTarget) {
                                        error = error.originalTarget.error;
                                    }
                                    logger.error('onFilePlayInputChange', 'error in playing this mp4 file', error);
                                } catch (err) {
                                    logger.error(
                                        'onFilePlayInputChange',
                                        'error in playing this mp4 file, and exception in extracting error code',
                                        err
                                    );
                                }
                            });

                            video.addEventListener('loadeddata', function (event) {
                                if (!self.abortFileShare) {
                                    if (!self.screenshareState) {
                                        self.msgflowEvent('start-video');
                                        self.startScreenShare();
                                    }
                                } else {
                                    self.removeFileVideo();
                                }
                            });

                            if (self.fixCaptureStream) {
                                video.addEventListener('loadedmetadata', function (event) {
                                    if (
                                        helperService.isWindows() &&
                                        helperService.getChromeVersion() >= 88 &&
                                        video &&
                                        video.videoWidth >= 1920 &&
                                        video.videoHeight >= 1080
                                    ) {
                                        logger.log(
                                            'videoFileShareService - Detected HD video share on Windows... showing alert and stopping video'
                                        );

                                        self.abortFileShare = true;
                                        self.showAlert(
                                            localizationService.translate('COMMON.OOPS_TEXT'),
                                            localizationService.translate(
                                                'SCREENSHARE.DIALOG.PLEASE_SHARE_VIDEO_WITH_RESOLUTION_720_OR_ABOVE'
                                            )
                                        );
                                    }
                                });
                            }

                            self.abortFileShare = false;
                            video.load();
                        }
                    }
                }
            }

            //Reset input value after playing
            $window.$('#videoroom-fileplay-upload').val('');
            digest();
        }

        function createFileVideo(previewStream) {
            var useAzureStreamPreview = shouldUseAzureStreamPreview(previewStream);
            var div = self.createVideoElement(
                true,
                useAzureStreamPreview ? previewStream : self.fileVideo,
                self.getScreenshareIdFromAttendantId(self.attendantId),
                true
            );

            $window.$(div).addClass('controls');
            configureFilePreviewVideo(div);
            createFilePreviewControls(div);

            // hacky way to check if this needs to be spotlight, only if current is gallery.
            if (
                (!self.maxvideo || self.talkerLayout == 'auto') &&
                (!self.layoutPage || self.layoutPageData.layout != 'allhands')
            ) {
                self.setSpotlightVideo(div);
                self.updateVideosLayout();
            }
            return div;
        }

        function removeFileVideo() {
            if (self.fileVideo) {
                var isAzurePreview = isAzureFilePreviewVdi();
                var previewId = self.getScreenshareIdFromAttendantId(self.attendantId);
                destroyFilePreviewControls();
                self.fileVideo.pause();
                var parentDiv = self.fileVideo.parentNode;
                self.fileVideo = null;
                self.fileplay = false;

                if (parentDiv instanceof DocumentFragment) {
                    //There is a case in which we do not add video to DOM due to invalid video resolution, etc.
                    //but the cleanup process will still go through stopScreenshare and removeFileVideo
                    //
                    //This results in the video div being a DocumentFragment, and for cleanup, we can just set it to null
                    parentDiv = null;
                }

                if (parentDiv) {
                    self.removeVideoElement(undefined, parentDiv);
                } else if (isAzurePreview) {
                    self.removeVideoElement(previewId);
                }
            }
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }

        function isAzureFilePreviewVdi() {
            var vdiRef = helperService.getVDIRef();
            return (
                !!vdiRef &&
                typeof vdiRef.getVdiType === 'function' &&
                vdiRef.getVdiType() === executionEnvironmentEnum.Azure
            );
        }

        function shouldUseAzureStreamPreview(previewStream) {
            return !!self.fileplay && !!previewStream && isAzureFilePreviewVdi();
        }

        function createFilePreviewControls(div) {
            if (!div || !self.fileVideo) {
                return;
            }

            if (!self.filePreviewControls) {
                self.filePreviewControls = videoPlaybackControlsBridge.mount($scope, div, self.fileVideo);
                return;
            }

            self.filePreviewControls = videoPlaybackControlsBridge.update(
                self.filePreviewControls,
                div,
                self.fileVideo
            );
        }

        function destroyFilePreviewControls() {
            if (!self.filePreviewControls) {
                return;
            }

            videoPlaybackControlsBridge.destroy(self.filePreviewControls);
            self.filePreviewControls = null;
        }

        function configureFilePreviewVideo(div) {
            var previewVideo = div && div.querySelector('video');
            if (!previewVideo) {
                return;
            }

            previewVideo.muted = true;
            previewVideo.volume = 0.001;
            previewVideo.removeAttribute('controls');
            previewVideo.style.pointerEvents = 'none';
            previewVideo.setAttribute('disablePictureInPicture', '');
            previewVideo.setAttribute('controlsList', 'nodownload nofullscreen noremoteplayback');
        }
    }
]);
